<template>
    <v-container fluid>
        <v-card>
            <v-card-title> Data Collection Task Schedule </v-card-title>
        </v-card>

        <!-- Readout Groups -->
        <experiment-readout-group-list
            :protocol="protocol"
            :experiment="experiment"
            :readoutGroups="readoutGroups"
            @saved="fetchTaskSchedule"
            @deleted="fetchTaskSchedule"
        />

        <task-reference-list
            :experiment="experiment"
            :protocol="protocol"
            :task-references="taskReferences"
            @saved="fetchTaskSchedule"
            @deleted="fetchTaskSchedule"
        />

        <task-thing-date-estimate-list
            :experiment="experiment"
            :protocol="protocol"
            :task-thing-date-estimates="taskThingDateEstimates"
            @saved="fetchTaskSchedule"
            @deleted="fetchTaskSchedule"
        />

        <!-- Task Groups -->
        <experiment-task-group-list
            v-if="taskSchedule != null"
            :experiment="experiment"
            :protocol="protocol"
            :task-schedule="taskSchedule"
            @saved="fetchTaskSchedule"
            @deleted="fetchTaskSchedule"
        />

        <!-- Data Collection Tasks -->
        <data-collection-task-list
            :experiment="experiment"
            :readoutGroups="readoutGroups"
            :taskGroups="taskGroups"
            :dataCollectionTasks="dataCollectionTasks"
            :protocol="protocol"
            :showMeasurementsButtons="false"
            @saved="fetchTaskSchedule"
            @deleted="fetchTaskSchedule"
        />
    </v-container>
</template>
<script>
import { defineComponent } from "vue";

import { taskScheduleAPI } from "@/services/api.services";
import { withLoadingScreen } from "@/lib/loading";
import DataCollectionTaskList from "../Measurements/DataCollectionTaskList.vue";
import TaskReferenceList from "../Measurements/TaskReferenceList.vue";
import TaskThingDateEstimateList from "../Measurements/TaskThingDateEstimateList.vue";
import ExperimentReadoutGroupList from "./ExperimentReadoutGroupList.vue";
import ExperimentTaskGroupList from "./ExperimentTaskGroupList.vue";

export default defineComponent({
    name: "experiment-tasks",

    components: {
        ExperimentTaskGroupList,
        ExperimentReadoutGroupList,
        TaskThingDateEstimateList,
        TaskReferenceList,
        DataCollectionTaskList,
    },

    props: {
        protocol: {
            type: Object, // AbstractSchemaConfig
            required: true,
        },
        experiment: {
            type: Object, // luxon DateTime
            required: false, // can be null
        },
    },

    data() {
        return {
            taskSchedule: null,
            readoutGroups: [],
            taskReferences: [],
            taskThingDateEstimates: [],
            taskGroups: [],
            dataCollectionTasks: [],
        };
    },

    async mounted() {
        await this.fetchTaskSchedule();
    },

    methods: {
        async fetchTaskSchedule() {
            await withLoadingScreen(async () => {
                const taskSchedule = await taskScheduleAPI.fetchTaskScheduleForExperimentCode(
                    this.experiment.code
                );
                this.renderTaskSchedule(taskSchedule);
            });
        },
        renderTaskSchedule(taskSchedule) {
            this.taskSchedule = taskSchedule;
            this.taskReferences = taskSchedule.taskReferences;
            this.taskThingDateEstimates = taskSchedule.taskThingDateEstimates;
            this.taskGroups = taskSchedule.taskGroups;
            this.readoutGroups = taskSchedule.readoutGroups;
            this.dataCollectionTasks = taskSchedule.dataCollectionTasks;
        },
    },
});
</script>
